module.exports = __webpack_public_path__ + "img/drt6.7ae9d276.png";